<template>
  <v-container fluid class="mt-0 pt-12" style="background-color: #fff">
    <v-row class="text-center " justify="center" align="center">
      <v-col md="4" lg="5" class="px-8" order="2" order-md="1">
        <h1 class="text-h3 text-purple font-weight-bold my-4">
          Achieve your goals and create new habits,
          <span class="text-pink">once and for all</span>
        </h1>
        <h2 class="text-h5 mb-8 font-weight-medium">
          the weekly planner that helps you stay motivated, track your progress,
          avoid burnout and never quit
        </h2>
        <v-img
          :src="require('@/assets/img/resolutions/finish_2.png')"
          aspect-ratio="1"
          contain
          class="mb-2"
          width="auto"
          height="400px"
          style="margin: 0 auto"
        ></v-img>
      </v-col>
      <v-col md="5" lg="4" xl="3" order="1" order-md="2">
        <v-card class="py-8" elevation="0">
          <v-card-text>
            <v-form
              :class="$vuetify.breakpoint.mdAndUp ? 'px-5' : ''"
              ref="signupForm"
              :lazy-validation="true"
              max-width="500px"
            >
              <p class="text-center text-pink font-weight-medium body-1">
                Welcome 👋
              </p>
              <h1
                class="display-2 mb-12 text-purple text-center font-weight-medium"
              >
                Sign up
              </h1>
              <v-text-field
                prepend-icon="fas fa-user"
                outlined
                dense
                v-model="signup.user"
                :autofocus="!prePopulated"
                name="name"
                label="Name"
                :rules="nameRules"
                required
              ></v-text-field>
              <v-text-field
                prepend-icon="fas fa-envelope"
                outlined
                dense
                v-model="signup.email"
                type="text"
                name="email"
                label="Email"
                :rules="emailRules"
                :readonly="prePopulated"
              ></v-text-field>
              <v-text-field
                :prepend-icon="pass_ok_icon"
                outlined
                dense
                v-model="signup.pass"
                :autofocus="prePopulated"
                type="password"
                name="password"
                label="Password"
                :rules="passRules"
              ></v-text-field>

              <v-text-field
                :prepend-icon="pass_ok_icon"
                outlined
                dense
                v-model="signup.pass_rep"
                type="password"
                name="password_repeat"
                label="Confirm your password"
                :rules="passrepRules"
                v-on:keyup.enter="handleSignup"
              ></v-text-field>
              <v-alert
                v-if="message.show"
                :type="message.type"
                outlined
                dense
                class="text-center body-2"
                >{{ message.text }}</v-alert
              >
              <v-btn
                primary
                dark
                color="secondary"
                class="my-5"
                :loading="isLoading"
                @click="handleSignup"
                >Create my account</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      signup: {
        user: '',
        pass: '',
        pass_rep: '',
        email: '',
      },

      isLoading: false,
      prePopulated: false,
      nameRules: [
        v => !!v || 'Name is required',
        v =>
          /^[\S]+$/.test(v) ||
          'Name should not contain spaces (just your first name 😉)',
      ],

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be a valid address',
      ],
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters',
      ],
      passrepRules: [
        v => !!v || 'Confirm password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters',
        v =>
          (v && v === this.signup.pass) ||
          'Password and confirmation should be the same',
      ],
      message: {
        show: false,
        text: 'Error. Check your details and try again',
        type: 'error',
      },
    }
  },
  mounted() {
    if (this.$route.query.name && this.$route.query.email) {
      this.signup.user = this.$route.query.name
      this.signup.email = this.$route.query.email
      this.prePopulated = true
    }
  },
  methods: {
    async handleSignup() {
      if (this.$refs.signupForm.validate()) {
        this.isLoading = true
        // dispatch action which return a Promise

        try {
          const user = await this.$store.dispatch('register', {
            body: {
              username: this.signup.email,
              name: this.signup.user,
              email: this.signup.email,
              password: this.signup.pass,
            },
          })
          // if register ok, redirect
          this.$router.push(`/@${user.name}/onboard`)
        } catch (e) {
          this.isLoading = false

          // show error in component
          if (e.data[0].messages[0].message)
            this.message.text = e.data[0].messages[0].message
          this.message.show = true
          this.isLoading = false
        }
      }
    },
    redirect(userData) {
      if (userData.goals.length > 0 || userData.habits.length > 0) {
        // redirect to week page
        this.$router.push(`/@${userData.name}/week`)
      }
      this.$router.push(`/@${userData.name}/goals-habits`)
      // OLD LOGIN ONBOARD/PROFILE
      // if (!userData.profile) {
      //   console.log('Redirecting to onboard')
      //   return this.$router.push({name: 'onboard'})
      // }
      // if (
      //   userData.profile.onboardInfo.onboarded ||
      //   userData.profile.onboardInfo.skipOnboard
      // ) {
      //   // return this.$router.push({name: 'onboard'})

      //   console.log('Redirecting to week')
      //   return this.$router.push(`/@${userData.username}/week`)
      // }
      // console.log('Redirecting to onboard')
      // return this.$router.push({name: 'onboard'})
    },
  },

  computed: {
    pass_ok_icon() {
      if (
        this.signup.pass.length >= 6 &&
        this.signup.pass_rep.length >= 6 &&
        this.signup.pass === this.signup.pass_rep
      ) {
        return 'fas fa-lock'
      }
      return 'fas fa-lock-open'
    },
  },
  metaInfo: {
    title: 'Sign Up',
    titleTemplate: '%s | theLIFEBOARD.app',
    link: [
      {
        rel: 'canonical',
        href: 'https://app.thelifeboard.app/early-access-signup',
      },
    ],
    // Define meta tags here.
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {
        name: 'description',
        content: 'The app that helps you achieve your goals and create habits',
      },
      // OpenGraph data (Most widely used)
      {
        property: 'og:title',
        content:
          'theLIFEBOARD - The app that helps you achieve your goals and create habits',
      },
      {property: 'og:site_name', content: 'theLIFEBOARD.app'},
      // The list of types is available here: http://ogp.me/#types
      {property: 'og:type', content: 'website'},
      // Should the the same as your canonical link, see below.
      {property: 'og:url', content: 'https://thelifeboard.app'},
      {
        property: 'og:image',
        content: 'https://thelifeboard.app/img/mails/mind_map.png',
      },
      // Often the same as your meta description, but not always.
      {
        property: 'og:description',
        content: 'The app that helps you achieve your goals and create habits',
      },

      // Twitter card
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:site', content: 'https://thelifeboard.app'},
      {name: 'twitter:title', content: 'theLIFEBOARD | Sign Up'},
      {
        name: 'twitter:description',
        content: 'The app that helps you achieve your goals and create habits',
      },
      // Your twitter handle, if you have one.
      {name: 'twitter:creator', content: '@the_life_board'},
      {
        name: 'twitter:image:src',
        content: 'https://thelifeboard.app/img/mails/mind_map.png',
      },

      // Google / Schema.org markup:
      {itemprop: 'name', content: 'theLIFEBOARD | Sign Up'},
      {
        itemprop: 'description',
        content: 'The app that helps you achieve your goals and create habits',
      },
      {
        itemprop: 'image',
        content: 'https://thelifeboard.app/img/mails/mind_map.png',
      },
    ],
  },
}
</script>

<style></style>
